// Same helper as the driver app — converts a relative photo path returned
// by the backend (e.g. "/uploads/vehicles/1/photo.jpg") into a full URL
// the browser can actually load.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export function getFullPhotoUrl(relativePath) {
  if (!relativePath) return null;
  return `${API_BASE_URL}${relativePath}`;
}
